import { useEffect } from "react"
import type { CSSProperties, RefObject } from "react"

const MAX_SECTIONS = 400
const measured = new Map<string, { height: number; width: number }>()
let observer: ResizeObserver | undefined

const remember = (id: string, height: number) => {
  measured.delete(id)
  measured.set(id, { height, width: window.innerWidth })
  if (measured.size > MAX_SECTIONS) measured.delete(measured.keys().next().value as string)
}

const rendered = (element: Element) => typeof element.checkVisibility === "function" && element.checkVisibility({ contentVisibilityAuto: true })

const sharedObserver = () =>
  (observer ??= new ResizeObserver((records) => {
    for (const { target, borderBoxSize } of records) {
      const id = target.getAttribute("data-feed-section")
      const height = Math.round(borderBoxSize[0]?.blockSize ?? 0)
      if (id && height > 0 && rendered(target)) remember(id, height)
    }
  }))

export const useSectionReserve = (ref: RefObject<HTMLElement | null>, id: string, enabled: boolean): CSSProperties | undefined => {
  useEffect(() => {
    const node = ref.current
    if (!enabled || !node) return
    const shared = sharedObserver()
    shared.observe(node)
    return () => shared.unobserve(node)
  }, [ref, enabled])

  const value = enabled ? measured.get(id) : undefined
  return value && value.width === window.innerWidth ? ({ "--section-reserve": `${value.height}px` } as CSSProperties) : undefined
}
